<template>
  <v-card class="document-folder-history-dialog" elevation="0" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Document History</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showHistory(showTab)" color="#3F4360">
        <img
          :src="computeRefreshLogo"
          alt="Refresh"
          class="height-24"
        />
      </v-btn>
    </v-toolbar>
    <v-card-text class="content">
      <v-tabs class="tab-btn">
        <v-tab @click="showHistory('DOCUMENT')">Document</v-tab>
        <v-tab @click="showHistory('LOAN_AGREEMENT')">Loan Agreement</v-tab>
      </v-tabs>
      <v-data-table
        v-if="showTab === 'DOCUMENT'"
        fixed-header
        :headers="documentHeaders"
        :items="documentDesserts"
        :loading="loading"
        hide-default-footer
        disable-pagination
        height="520px"
      >
        <template v-slot:item.documentType="{ item }">
          {{ assist.tool.getEnumTextByValue(assist.dataType.DocumentTypeEnum, item.documentType) }}
        </template>
        <template v-slot:item.operator="{ item }">
          {{ assist.tool.getFullName(item.operatedBy) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                color="green"
                v-if="item.documentUrl"
                class="mr-2"
                @click="downloadUrlOfDocument(item)"
                v-on="on"
              >
                arrow_circle_down
              </v-icon>
            </template>
            <span>Download</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-data-table
        v-if="showTab === 'LOAN_AGREEMENT'"
        fixed-header
        :headers="loanAgreementHeaders"
        :items="loanAgreementDesserts"
        :loading="loading"
        hide-default-footer
        disable-pagination
        height="520px"
      >
        <template v-slot:item.signStatus="{ item }">
          {{ assist.tool.getEnumTextByValue(assist.dataType.SignStatusEnum, item.signStatus) }}
        </template>
        <template v-slot:item.documentName="{ item }">
          {{ getDocumentNameByUrl(item.documentUrl)}}
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom v-if="item.documentUrl">
            <template v-slot:activator="{ on }">
              <v-icon
                color="#5C82E3"
                @click="downloadUrl(item.documentUrl)"
                v-on="on"
              >
                arrow_circle_down
              </v-icon>
            </template>
            <span>Download</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isShowRecoverBtn(item)">
            <template v-slot:activator="{ on }">
              <v-icon
                color="#5C82E3"
                @click="recoverLoanAgreement(item)"
                v-on="on"
              >
                settings_backup_restore
              </v-icon>
            </template>
            <span>Recover</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isShowVoidBtn(item)">
            <template v-slot:activator="{ on }">
              <v-icon
                color="red"
                @click="voidLoanAgreement(item)"
                v-on="on"
              >
                remove_circle_outline
              </v-icon>
            </template>
            <span>Void</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { OriginationBusinessApi, OriginationApi } from '@/api/pandaria'
import refreshImg from '@/assets/icons/icon_refresh@3x.png'
import axios from 'axios'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'document-history',
  props: {
    loan: {
      type: Object,
      default: () => {}
    },
    authorization: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      assist: {
        tool: new Tool(),
        dataType: DataType
      },
      restricts: this.authorization.restricts,
      allowLoanStatus: [
        DataType.LoanStatus.AGENT_REVIEW.value,
        DataType.LoanStatus.CORRECTOR_REVIEW.value
      ],
      documentHeaders: [
        { text: 'Document Name', value: 'documentName' },
        { text: 'Document Type', value: 'documentType' },
        { text: 'Create Time', value: 'createTime' },
        { text: 'Operator', value: 'operator' },
        { text: 'Action', value: 'action' }
      ],
      documentDesserts: [],
      loanAgreementHeaders: [
        { text: 'Document Name', value: 'documentName' },
        { text: 'Create Time', value: 'createTime' },
        { text: 'Status', value: 'signStatus' },
        { text: 'Action', value: 'action' }
      ],
      loanAgreementDesserts: [],
      loading: false,
      showTab: 'DOCUMENT'
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    computeRefreshLogo () {
      return refreshImg
    }
  },
  watch: {
    loanId () {
      this.showHistory('DOCUMENT')
    }
  },
  methods: {
    isShowRecoverBtn (item) {
      let result = false
      if ((this.allowLoanStatus.includes(this.loan.loanStatus) || this.hasRestricts()) &&
        item.isOverBatchDeadline === false &&
        item.documentType === DataType.DocumentTypeEnum.LOAN_AGREEMENT.value &&
        tool.isNotEmpty(item.signStatus) && parseInt(item.signStatus) === DataType.SignStatusEnum.VOIDED.value) {
        result = true
      }
      return result
    },
    isShowVoidBtn (item) {
      let result = false
      if ((this.allowLoanStatus.includes(this.loan.loanStatus) || this.hasRestricts()) &&
        item.documentType === DataType.DocumentTypeEnum.LOAN_AGREEMENT.value && tool.isNotEmpty(item.signStatus) && parseInt(item.signStatus) === DataType.SignStatusEnum.SIGNED.value) {
        result = true
      }
      return result
    },
    hasRestricts () {
      let result = false
      const loanStatus = this.loan.loanStatus
      if (tool.isNotEmpty(this.restricts)) {
        for (const item of this.restricts) {
          if (loanStatus === item.loanStatus) {
            result = true
            break
          }
        }
      }
      return result
    },
    showHistory (tabName) {
      const $this = this
      $this.showTab = ''
      $this.showTab = tabName
      $this.documentDesserts = []
      $this.loanAgreementDesserts = []
      const request = {
        loanId: $this.loan.id,
        loanNo: $this.loan.loanNo,
        loanType: $this.loan.loanType
      }
      $this.loading = true
      switch (tabName) {
        case 'DOCUMENT': {
          this.$eventBus.$emit('documentType', 'DOCUMENT')
          OriginationApi.listDocumentData(request, function (result) {
            $this.documentDesserts = tool.isEmpty(result) ? [] : result
            $this.loading = false
            $this.$forceUpdate()
          }, function () {
            $this.documentDesserts = []
            $this.loading = false
            $this.$forceUpdate()
          })
          break
        }
        case 'LOAN_AGREEMENT': {
          this.$eventBus.$emit('documentType', 'LOAN_AGREEMENT')
          OriginationBusinessApi.listLoanAgreementDocument(request, function (result) {
            $this.loanAgreementDesserts = tool.isEmpty(result) ? [] : result
            $this.loading = false
            $this.$forceUpdate()
          }, function () {
            $this.loanAgreementDesserts = []
            $this.loading = false
            $this.$forceUpdate()
          })
          break
        }
      }
    },
    getDocumentNameByUrl (documentUrl) {
      let result = ''
      if (tool.isNotEmpty(documentUrl)) {
        try {
          result = documentUrl.substring(documentUrl.lastIndexOf('/') + 1)
        } catch (e) {}
      }
      return result
    },
    downloadUrlOfDocument (item) {
      const $this = this
      if (item.documentType === DataType.DocumentTypeEnum.CRC.value) {
        axios.get('/gateway/platform-lmsapi/download-document', {
          params: {
            fileName: item.documentName,
            destination: item.documentUrl
          },
          responseType: 'blob'
        }).then(res => {
          const blob = new Blob([res.data], { type: res.data.type })
          const url = window.URL.createObjectURL(blob)
          const elink = document.createElement('a')
          elink.download = res?.headers['content-disposition'].split(';')[1].split('filename=')[1] + '.pdf'
          elink.style.display = 'none'
          elink.href = url
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }).catch(err => {
          popup.popupForWarning(err.message)
        })
      } else {
        $this.downloadUrl(item.documentUrl)
      }
    },
    downloadUrl (url) {
      if (tool.isNotEmpty(url)) {
        const rep = new RegExp('http:')
        const currentUrl = url.replace(rep, 'https:')
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = currentUrl
        link.click()
      }
    },
    voidLoanAgreement (item) {
      const $this = this
      popup.popupForQuestion('Are you sure to void this loan agreement?', null, function () {
        const request = {
          loanId: $this.loan.id,
          documentId: item.documentId
        }
        OriginationBusinessApi.voidLoanAgreementByDocumentIdAndLoanId(request, function (result) {
          popup.popupForSuccess('Void document has been triggered, please wait for the response')
          $this.showHistory($this.showTab)
        }, function () {
          popup.popupForWarning('Failed to void loan agreement')
        })
      })
    },
    recoverLoanAgreement (item) {
      const $this = this
      popup.popupForQuestion('Do you confirm recover this loan agreement? This is a very dangerous operation and the old data will replace the current application data!', null, function () {
        const request = {
          loanId: $this.loan.id,
          documentId: item.documentId
        }
        OriginationBusinessApi.recoverLoanAgreement(request, function () {
          popup.popupForSuccess('Recover document has been triggered, please wait for the response')
        }, function () {
          popup.popupForWarning('Failed to recover loan agreement')
        })
      })
    }
  }
}
</script>
<style>
.document-folder-history-dialog .document {
  width: 160px;
  color: #002B7F;
  display: inline-block;
}

.document-folder-history-dialog .document-type {
  margin-bottom: 5px;
  font-size: 100px;
  line-height: 100px;
}
.document-folder-history-dialog .content {
  max-height: 600px;
  overflow: auto;
}
.toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none;
}
</style>
